module.exports = __webpack_public_path__ + "static/img/hy.0f28e87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hy.png
// module id = //cD
// module chunks = 1